import { Typography } from '@mui/material';
import React from 'react';

const NoDataMessage = ({ findItemType }) => {
    return (
        <div>
            <Typography variant="h6" component="div" sx={{
                p: 2,
                textAlign: "center"
            }}>
                No Data Available
            </Typography>
            < Typography component="p"
                sx={{
                    textAlign: "center"
                }}>
                There are no {findItemType} available for the selected time period.
                Please choose a different date range.
            </Typography>
        </div>
    );
};

export default NoDataMessage;
